import { IEnvConfig } from '..'

const config: IEnvConfig = {
  name: 'DEV',
  CONNECTORS: {
    ROOT: {
      baseUrl: 'http://localhost:5002',
    },
    SSO: {
      baseUrl: 'http://api.moverse.biz',
    }
  },
}

export default config
